import React from "react";
import Cookies from "universal-cookie";
import getCorso from "../../services/getCorso";
import getValutazioniCorso from "../../services/getValutazioniCorso";
import getEsami from "../../services/getEsami";
import getStudenti from "../../services/getStudenti";
import moment from "moment";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import getCambioCorsoStudente from "../../services/getCambioCorsoStudente";

export default class PDfFullCourse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainAverages: [],
      votiPrecedenti: [],
      isReadyToShow: false,
      totalPages: 0,
    };
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCorso = cookies.get("currentCourse", { path: "/" });

    this.corso = await getCorso(username, token, currentCorso);
    this.valutazioni = await getValutazioniCorso(
      username,
      token,
      this.corso.id
    );
    this.esami = await getEsami(username, token, this.corso.id);
    this.studenti = await getStudenti(username, token);
    this.studenti = this.studenti.filter((s) => {
      const corsiArray = s.corsi.split(";").filter(Boolean);
      const corsiRitiroArray = s.corsi_ritiro.split(";").filter(Boolean);
      return (
        corsiArray.includes(this.corso.id.toString()) &&
        !corsiRitiroArray.includes(this.corso.id.toString())
      );
    });

    this.studenti.sort((s1, s2) => s1.cognome.localeCompare(s2.cognome));

    const corsiData = await getCambioCorsoStudente(
      username,
      token,
      currentCorso
    );

    // AGGREGAZIONE: Raggruppa i cambi corso per studente (come in EditCorso)
    const studentiMap = {};

    if (corsiData && Array.isArray(corsiData)) {
      corsiData.forEach((cambio) => {
        const idStudente = cambio.id_studente;

        // Se lo studente non esiste ancora nella mappa, crealo
        if (!studentiMap[idStudente]) {
          const foundStud = this.studenti.find((s) => s.id === idStudente);
          studentiMap[idStudente] = {
            id_studente: idStudente,
            nome: foundStud?.nome || "",
            cognome: foundStud?.cognome || "",
            _esamiOriginali: {}, // Mappa chiave normalizzata -> {nome, data, valutazione}
          };
        }

        // SOVRASCRIVI sempre i voti (per cambi corso multipli A→B→C)
        // L'ultimo voto trovato ha priorità (corso più recente)
        if (
          cambio.info_corso_precedente &&
          cambio.info_corso_precedente.voti_corso_precedente
        ) {
          cambio.info_corso_precedente.voti_corso_precedente.forEach(
            (esame) => {
              const chiaveEsame = esame.nome_esame
                .replace(/\s+/g, "")
                .toLowerCase(); // Case-insensitive come EditCorso

              studentiMap[idStudente][chiaveEsame] = esame.valutazione;
              studentiMap[idStudente]._esamiOriginali[chiaveEsame] = {
                nome: esame.nome_esame,
                data: esame.data || null,
                valutazione: esame.valutazione,
              };
            }
          );
        }
      });
    }

    // Converti la mappa in array
    const votiPrecedenti = Object.values(studentiMap);

    this.setState({ votiPrecedenti });

    let mainAverages = [];
    let averages = [];
    let ind = 0;

    this.studenti.forEach((studente) => {
      const esamiAttuali = this.valutazioni.filter(
        (esame) => esame.id_studente == studente.id && esame.valutazione != -1
      );
      let sommaAttuali = 0;
      esamiAttuali.forEach((esame) => {
        sommaAttuali += parseFloat(esame.valutazione);
      });
      const countAttuali = esamiAttuali.length;

      const prevRecord = votiPrecedenti.find(
        (item) => item.id_studente == studente.id
      );
      let sommaPrecedenti = 0;
      let countPrecedenti = 0;
      if (prevRecord) {
        for (let key in prevRecord) {
          if (
            ["id_studente", "nome", "cognome", "_esamiOriginali"].includes(key)
          )
            continue;
          if (prevRecord[key] !== undefined && prevRecord[key] !== null) {
            sommaPrecedenti += parseFloat(prevRecord[key]);
            countPrecedenti++;
          }
        }
      }

      const totalCount = countAttuali + countPrecedenti;
      const totalSum = sommaAttuali + sommaPrecedenti;
      const overallAverage =
        totalCount > 0 ? (totalSum / totalCount).toFixed(2) : "N/A";

      const record = [
        studente.cognome.toUpperCase() + " " + studente.nome.toUpperCase(),
        overallAverage,
      ];
      averages.push(record);
      if (averages.length === 15 || ind === this.studenti.length - 1) {
        mainAverages.push(averages);
        averages = [];
      }
      ind++;
    });

    this.setState({
      mainAverages: mainAverages,
      totalPages: mainAverages.length,
      isReadyToShow: true,
    });
  }

  render() {
    const timeNow = moment().format("yyyy-MM-DD HH:mm:ss");

    return (
      <div style={{ width: "100%", height: "100%" }} key={Math.random()}>
        {this.state.isReadyToShow && (
          <PDFViewer style={{ width: "100%", height: "100%" }}>
            <Document>
              {this.state.mainAverages.map((gruppo, index) => {
                return (
                  <Page
                    key={index}
                    size="A4"
                    style={{ paddingTop: 80, paddingBottom: 50 }}
                    orientation="portrait"
                    wrap
                  >
                    <View style={{ marginTop: -60, height: "100%" }}>
                      <Image
                        style={{
                          position: "absolute",
                          top: 30,
                          left: 30,
                          width: "20%",
                          height: "auto",
                        }}
                        src={require("../../images/loghi/nero_trasparente.png")}
                      />
                      <Text
                        style={{
                          position: "absolute",
                          top: 45,
                          right: 30,
                          fontSize: 12,
                          width: "100%",
                          textAlign: "right",
                          color: "#999999",
                        }}
                      >
                        {timeNow}
                      </Text>
                      <Text
                        style={{
                          margin: 10,
                          fontSize: 20,
                          width: "100%",
                          textAlign: "center",
                          marginTop: "100px",
                        }}
                      >
                        Valutazioni medie
                      </Text>
                      <Text
                        style={{
                          fontSize: 20,
                          marginLeft: 10,
                          marginRight: 10,
                          width: "100%",
                          maxHeight: 100,
                          textAlign: "center",
                          marginTop: "5px",
                          color: "#999999",
                          paddingHorizontal: 40,
                        }}
                      >
                        {this.corso.name}
                      </Text>
                      <View style={styles.page}>
                        <View style={styles.row}>
                          <View
                            style={{
                              ...styles.columnLeft,
                              textAlign: "center",
                            }}
                          >
                            <Text>STUDENTE</Text>
                          </View>
                          <View
                            style={{
                              ...styles.columnRight,
                              textAlign: "center",
                            }}
                          >
                            <Text>MEDIA</Text>
                          </View>
                        </View>
                        {gruppo.map((media, i) => (
                          <View
                            key={i}
                            style={{ ...styles.row, marginTop: -1 }}
                          >
                            <View style={styles.columnLeft}>
                              <Text style={{ alignItems: "center", flex: 1 }}>
                                {media[0]}
                              </Text>
                            </View>
                            <View style={styles.columnRight}>
                              <Text style={{ alignItems: "center", flex: 1 }}>
                                {media[1]}
                              </Text>
                            </View>
                          </View>
                        ))}
                      </View>
                    </View>
                    <View
                      style={{
                        position: "absolute",
                        bottom: 50,
                        left: 0,
                        width: "100%",
                        backgroundColor: "#FFFFFF",
                        textAlign: "right",
                      }}
                    >
                      <Text
                        style={{
                          fontWeight: "light",
                          fontSize: 9,
                          color: "#BDBDBD",
                          marginRight: 50,
                        }}
                      >
                        Pagina {index + 1} di {this.state.totalPages}
                      </Text>
                    </View>
                  </Page>
                );
              })}
            </Document>
          </PDFViewer>
        )}
      </div>
    );
  }
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    display: "flex",
    border: "1 solid #000",
    width: "90%",
    marginLeft: "5%",
    minHeight: "30px",
  },
  page: {
    fontSize: 10,
    backgroundColor: "#ffffff",
    padding: 10,
    marginTop: "20px",
  },
  columnLeft: {
    flexDirection: "column",
    width: "50%",
    borderRight: "1 solid #000",
    textAlign: "left",
    paddingHorizontal: 30,
    paddingVertical: 10,
    flex: 1,
  },
  columnRight: {
    flexDirection: "column",
    textAlign: "center",
    paddingHorizontal: 30,
    paddingVertical: 10,
    flex: 1,
  },
});
